/**
 * Tries to parse a string into a decimal number.
 *
 * @param value - The string to parse.
 * @returns The parsed number if successful; otherwise, NaN.
 *
 * @example
 *   tryParseDecimal('123.45'); // 123.45
 *   tryParseDecimal('abc');    // NaN
 */
export const tryParseDecimal = (value: string): number => {
  const result = parseFloat(value);
  if (!isNaN(result) && isFinite(result)) {
    return result;
  }
  return NaN;
};
